export default __webpack_public_path__ + "static/media/fowler-plant-aerial.07125602.jpg";